import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

declare var $:any;

@Injectable()
export class DrawingToolsService {
    
    constructor(private http: HttpClient) { }

    public getDrawingToolsDefaultConfig() {
        let config = {
            isDrawingToolsActive:  false,
            currentTool: 'pen',
            strokeColor: '#000000',
            strokewidth: 6,
            opacity: 1.0,
            defaultFontSize: undefined,
            type: undefined,
            undoStack: new Array(),
            redoStack: new Array(),
            showStage: true,
            drawingPanelConfig: {
                "tab-order" : ["pen", "highlighter", "eraser"],
                "tabs" : {
                    "pen" : {
                        "icon" : "nemo-font nemo-edit-pencil",
                        "key" : "PEN",
                        "font-size" : ["2px", "6px", "10px", "14px"],
                        "background-color" : ["#000000", "#0002FF", "#B90000", "#00B32E"],
                        "value" : {
                            "font-size" : "6px",
                            "background-color" : "#000000"
                        }
                    },
                    "highlighter" : {
                        "icon" : "nemo-font nemo-highlighter",
                        "key" : "HIGHLIGHTER",
                        "font-size" : ["4px", "16px", "20px", "24px"],
                        "background-color" : ["#FFFF00", "#75F8F8", "#F878F8", "#78F878"],
                        "value" : {
                            "font-size" : "16px",
                            "background-color" : "#FFFF00"
                        }
                    },
                    "eraser" : {
                        "icon" : "nemo-font nemo-eraser",
                        "key" : "ERASER",
                        "properties" : ["erase", "delete"]
                    }
                }
            },
            singleContinuousLine: {
                "startPageDIV" : undefined,
                "currentPageDIV" : undefined,
                "lastPosition" : undefined,
                "lastLine" : undefined,
                "isSingleContinuousLine" : undefined,
                "id" : undefined 
            },
            maxSizeAllowed : 153600, // max size of drawings allowed per page (in bytes).
            "currentSize-A" : 0,
            "currentSize-B" : 0

        };
        return config;
    }
}

   